import { ApplicationRoutes } from '../../../app-routes-names'

export const DashboardRoutes = {
  weekOverWeek: 'week-over-week'
}

const { dashboard } = ApplicationRoutes

export const DashboardPaths = {
  weekOverWeek: `/${dashboard}/${DashboardRoutes.weekOverWeek}`
}
